
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Block } from '@/types/block';
import moment from 'moment';

@Component
export default class BlockListTile extends Vue {
  @Prop() block!: Block;

  /* get updatedDate(): string {
    return this.fromNow(this.page.updated_at);
  } */

  fromNow(fromDate: string): string {
    const fromMoment: moment.Moment = moment(fromDate);
    const now: moment.Moment = moment();
    return now.diff(fromMoment, 'days') > 1
      ? fromMoment.calendar()
      : fromMoment.fromNow();
  }
}
